import { fetchUtils, HttpError, Identifier } from 'react-admin';
import {
  createReactAdminValidationError,
  getJsonApiErrorBody,
  getJsonApiErrorMessage,
  getJsonApiErrorStatus,
} from '../../JsonApiTypes';

export interface SyncWithNetSuiteResponse {
  meta: {
    netSuiteCustomerId: number;
    message: string;
  };
}

export type SyncWithNetSuite = (merchantId: Identifier) => Promise<SyncWithNetSuiteResponse | null>;

export default function syncWithNetSuite(
  apiUrl: string,
  httpClient = fetchUtils.fetchJson,
): SyncWithNetSuite {
  return async (merchantId) => {
    try {
      const response = await httpClient(`${apiUrl}/merchants/${merchantId}/sync-netsuite`, {
        method: 'POST',
      });

      return response.json == null ? null : (response.json as SyncWithNetSuiteResponse);
    } catch (error) {
      const validationErrors = createReactAdminValidationError(error as HttpError);
      throw new HttpError(
        getJsonApiErrorMessage(error as HttpError, 'Error syncing merchant with NetSuite'),
        getJsonApiErrorStatus(error as HttpError),
        {
          ...validationErrors,
          apiResponse: getJsonApiErrorBody(error),
        },
      );
    }
  };
}
